import Icon from '@components/v2/ui/Icon/Icon';
import { ArrowLeftRight } from 'lucide-react';
import useMoney from '../../../../../../hooks/useMoney';
import LangEnum from '../../../../../../lang/LangEnum';
import { InstallmentStatusEnum } from '../../../../../accountsReceivable/types/accountsReceivable.types';
import { AccountReceivableSearchResultItem } from '../../../../globalSearch.types';
import HighlightedText from '../../../HighlightedText';
import StatusBadge from '../../../StatusBadge/StatusBadge';
import ResultRowBase from '../../ResultRowBase';
import { ResultRowRendererProps } from '../../resultRow.types';
import { formatOptionalMoney, joinResultParts } from '../../resultRow.utils';

interface AccountReceivableStatusConfig {
  label: LangEnum;
  color: string;
}

const STATUS_CONFIG: Record<string, AccountReceivableStatusConfig> = {
  [InstallmentStatusEnum.PAID]: { label: LangEnum.GLOBAL_RECEIVED_FEMININE, color: 'success.main' },
  [InstallmentStatusEnum.PENDING]: { label: LangEnum.GLOBAL_DUE, color: 'warning.main' },
  [InstallmentStatusEnum.OVERDUE]: {
    label: LangEnum.ACCOUNTS_RECEIVABLE_OVERDUE,
    color: 'error.main',
  },
};

function AccountReceivableRow({
  item,
  query,
  isActive,
  isDisabled,
  domId,
  onSelect,
}: ResultRowRendererProps<AccountReceivableSearchResultItem>) {
  const { formatMoney } = useMoney();

  const statusConfig = STATUS_CONFIG[item.status?.toUpperCase()];
  const subtitle = joinResultParts([
    formatOptionalMoney(item.value, formatMoney),
    item.customerName,
  ]);

  return (
    <ResultRowBase
      testId={`global-search-item-${item.entityType}-${item.id}`}
      isActive={isActive}
      isDisabled={isDisabled}
      domId={domId}
      onClick={onSelect}
      leading={<Icon icon={ArrowLeftRight} size="md" />}
      title={<HighlightedText text={item.title} query={query} />}
      subtitle={subtitle ? <HighlightedText text={subtitle} query={query} /> : undefined}
      line1Trailing={
        statusConfig && <StatusBadge label={statusConfig.label} color={statusConfig.color} />
      }
    />
  );
}

export default AccountReceivableRow;
